import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {runInAction } from "mobx"
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import type {NewSearchWidgetState} from "../models/new-search-widget.state";

export class NewSearchWidgetSportTypeMenuClickHandler extends ActionHandler {
  state: NewSearchWidgetState;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeMenuClick;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    runInAction(() => {
      this.state.isSportTypeMenuOpen = params.isOpen;
    })
  }
}
